import React from "react";
import { Document, Page } from "react-pdf";

const ThumbnailLoading = () => (
  <div className="w-full p-2 space-y-1.5" style={{ aspectRatio: "3 / 4" }}>
    <div className="h-1 bg-gray-200 rounded" />
    <div className="h-1 bg-gray-200 rounded w-5/6" />
    <div className="h-1 bg-gray-200 rounded w-3/4" />
    <div className="h-1 bg-gray-200 rounded w-11/12" />
    <div className="h-1 bg-gray-200 rounded w-2/3" />
    <div className="h-1 bg-gray-200 rounded w-5/6" />
  </div>
);

const StatusBadge = ({ ps }) => {
  if (ps.review > 0) {
    return (
      <span
        title={`${ps.review} need review`}
        className="absolute -top-1.5 -right-1.5 w-4 h-4 rounded-full bg-[#FBBF24] text-white text-[10px] font-bold flex items-center justify-center shadow"
      >
        !
      </span>
    );
  }
  if (ps.total > 0 && ps.unanswered === 0) {
    return (
      <span
        title="All answered"
        className="absolute -top-1.5 -right-1.5 w-4 h-4 rounded-full bg-[#22C55E] text-white text-[10px] font-bold flex items-center justify-center shadow"
      >
        ✓
      </span>
    );
  }
  if (ps.total > 0) {
    return (
      <span
        title={`${ps.unanswered} unanswered · ${ps.total} field${
          ps.total === 1 ? "" : "s"
        } on this page`}
        className="absolute -top-1.5 -right-1.5 min-w-[16px] h-4 px-1 rounded-full bg-[#C95EBE] text-white text-[10px] font-bold flex items-center justify-center shadow"
      >
        {ps.total}
      </span>
    );
  }
  return null;
};

const PageThumbnailsSidebar = ({
  fileObj,
  totalPages,
  pageStats,
  currentPage,
  onGoToPage,
}) => {
  if (!totalPages) return null;

  return (
    <aside className="w-[120px] flex-shrink-0 border-l border-gray-200 bg-white flex flex-col">
      <div className="px-3 py-3 border-b border-gray-100 text-[11px] font-semibold uppercase tracking-[0.1em] text-[#52525B]">
        Pages
      </div>
      <div className="flex-1 overflow-y-auto py-3 px-3 space-y-3">
        <Document file={fileObj} loading={null} error={null} noData={null}>
          {Array.from({ length: totalPages }).map((_, idx) => {
            const ps = pageStats[idx] || {
              total: 0,
              answered: 0,
              review: 0,
              unanswered: 0,
            };
            const isActive = currentPage === idx;
            return (
              <button
                key={idx}
                type="button"
                onClick={() => onGoToPage(idx)}
                title={`Go to page ${idx + 1}${
                  ps.total > 0 ? ` · ${ps.answered}/${ps.total} answered` : ""
                }`}
                className="w-full focus:outline-none block"
              >
                <div className="relative">
                  <div
                    className={`w-full bg-white rounded-md shadow-sm transition-all overflow-hidden border flex items-center justify-center ${
                      isActive
                        ? "border-[#C95EBE] ring-2 ring-[#C95EBE]/30"
                        : "border-gray-200 hover:border-gray-300"
                    }`}
                    style={{ minHeight: 110 }}
                  >
                    <Page
                      pageNumber={idx + 1}
                      width={92}
                      renderAnnotationLayer={false}
                      renderTextLayer={false}
                      loading={<ThumbnailLoading />}
                    />
                  </div>
                  <StatusBadge ps={ps} />
                </div>
                <div
                  className={`mt-1 text-center text-[11px] font-medium ${
                    isActive ? "text-[#C95EBE]" : "text-[#71717A]"
                  }`}
                >
                  {idx + 1}
                </div>
              </button>
            );
          })}
        </Document>
      </div>
    </aside>
  );
};

export default PageThumbnailsSidebar;
